import React, { useState, useEffect, useContext, useRef } from "react";
import { Carousel, Image, Modal } from "antd";
import { ItemInfoWrapper } from "../../container/Styles/Wrappers";
import { addToCart } from "../../library/database";
import { AppContext } from "../../context";
import { ENTITIES } from "../../entities/entitiesConfig";
import AddedToCartInfo from "./AddedToCartInfo";
import SpecialRequest from "./SpecialRequest";
import AddToCart from "./AddToCart";

function AddToCartDialog({
  entity,
  store,
  product,
  isAddedToCartVisible,
  setIsAddedToCartVisible,
}) {
  const [addedToCart, setAddedToCart] = useState(false);
  const [clientRequest, setClientRequest] = useState("");
  const info = useContext(AppContext);

  const handleAddToCart = async () => {
    setAddedToCart(true);

    if (ENTITIES[entity].addToCart)
      await ENTITIES[entity].addToCart(
        entity,
        store,
        product,
        info,
        clientRequest
      );
    else await addToCart(entity, store, product, info, clientRequest);
    // info.setRefresh(!info.refresh);
  };

  console.log("addToCart");

  return (
    <Modal
      visible={isAddedToCartVisible}
      onOk={() => setIsAddedToCartVisible(false)}
      onCancel={() => {
        setIsAddedToCartVisible(false);
        info.setRefresh(!info.refresh);
        console.log("cancel");
      }}
      footer={[]}
      width="auto"
      style={{ maxWidth: "600px", paddingTop: 0 }}
      bodyStyle={{ maxHeight: "60vh", overflow: "scroll" }}
      mask
      maskClosable={false}
    >
      <ItemInfoWrapper>
        <div className="carousel-container">
          <Carousel>
            {product?.gen_files?.map((im, index) => (
              <Image alt={im.alt} src={im.url} height={400} key={index} />
            ))}
          </Carousel>
        </div>

        <div className="title">
          <h1 className="item-name">{product?.gen_name}</h1>
          <h2 className="item-parent">{store?.name}</h2>
        </div>

        <div className="add-to-cart-dialog-content">
          {!addedToCart && (
            <>
              <SpecialRequest setClientRequest={setClientRequest} />

              {React.createElement(ENTITIES[entity].CardContent, {
                entity,
                store,
                product,
                context: "reservation-info",
                setIsAddedToCartVisible,
                setAddedToCart,
                clientRequest,
              })}

              {/* REMOVE - after adding AddToCart to the CardContent component of each entity, remove this */}
              {entity !== "rentacar" &&
                entity !== "rentabike" &&
                entity !== "monument" &&
                entity !== "goods" && (
                  <AddToCart
                    setIsAddedToCartVisible={setIsAddedToCartVisible}
                    handleAddToCart={handleAddToCart}
                  />
                )}
            </>
          )}
        </div>
        {addedToCart && (
          <AddedToCartInfo setIsAddedToCartVisible={setIsAddedToCartVisible} />
        )}
      </ItemInfoWrapper>
    </Modal>
  );
}

// export default React.memo(AddToCartDialog);
export default AddToCartDialog;
